import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DomEventService {

  public constructor() { }

  public emitEvent(type: string, sourceToEmitFrom: EventTarget,  data?: any) {
    const event = new CustomEvent(type, {
      bubbles: true,
      detail: data,
    });

    sourceToEmitFrom.dispatchEvent(event);
  }
}
